import {
  createTicketDefinition as publicCreateTicketDefinition,
  updateTicketDefinition as publicUpdateTicketDefinition,
  getTicketDefinition as publicGetTicketDefinition,
  deleteTicketDefinition as publicDeleteTicketDefinition,
  reorderTicketDefinitions as publicReorderTicketDefinitions,
  queryTicketDefinitions as publicQueryTicketDefinitions,
  typedQueryTicketDefinitions as publicTypedQueryTicketDefinitions,
  queryAvailableTicketDefinitions as publicQueryAvailableTicketDefinitions,
  countTicketDefinitions as publicCountTicketDefinitions,
  countAvailableTicketDefinitions as publicCountAvailableTicketDefinitions,
  bulkDeleteTicketDefinitionsByFilter as publicBulkDeleteTicketDefinitionsByFilter,
  changeCurrency as publicChangeCurrency,
} from './events-v3-ticket-definition-ticket-definitions-v-2.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  QueryTicketDefinitionsOptions,
  TicketDefinitionQuery,
  TicketDefinitionsQueryBuilder,
  typedQueryTicketDefinitions as universalTypedQueryTicketDefinitions,
} from './events-v3-ticket-definition-ticket-definitions-v-2.universal.js';
import { onTicketDefinitionCreated as publicOnTicketDefinitionCreated } from './events-v3-ticket-definition-ticket-definitions-v-2.public.js';
import { onTicketDefinitionDeleted as publicOnTicketDefinitionDeleted } from './events-v3-ticket-definition-ticket-definitions-v-2.public.js';
import { onTicketDefinitionSaleEnded as publicOnTicketDefinitionSaleEnded } from './events-v3-ticket-definition-ticket-definitions-v-2.public.js';
import { onTicketDefinitionSalePeriodUpdated as publicOnTicketDefinitionSalePeriodUpdated } from './events-v3-ticket-definition-ticket-definitions-v-2.public.js';
import { onTicketDefinitionSaleStarted as publicOnTicketDefinitionSaleStarted } from './events-v3-ticket-definition-ticket-definitions-v-2.public.js';
import { onTicketDefinitionUpdated as publicOnTicketDefinitionUpdated } from './events-v3-ticket-definition-ticket-definitions-v-2.public.js';

function customQueryTicketDefinitions(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryTicketDefinitionsOptions) =>
      publicQueryTicketDefinitions(httpClient)(options),
    typedQueryFunction: (
      query: TicketDefinitionQuery,
      options?: QueryTicketDefinitionsOptions
    ) => publicTypedQueryTicketDefinitions(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: TicketDefinitionQuery,
    options?: QueryTicketDefinitionsOptions
  ): ReturnType<typeof universalTypedQueryTicketDefinitions>;
  function overloadedQuery(
    options?: QueryTicketDefinitionsOptions
  ): TicketDefinitionsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: TicketDefinitionQuery | QueryTicketDefinitionsOptions,
    options?: QueryTicketDefinitionsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createTicketDefinition: MaybeContext<
  BuildRESTFunction<typeof publicCreateTicketDefinition> &
    typeof publicCreateTicketDefinition
> = /*#__PURE__*/ createRESTModule(publicCreateTicketDefinition);
export const updateTicketDefinition: MaybeContext<
  BuildRESTFunction<typeof publicUpdateTicketDefinition> &
    typeof publicUpdateTicketDefinition
> = /*#__PURE__*/ createRESTModule(publicUpdateTicketDefinition);
export const getTicketDefinition: MaybeContext<
  BuildRESTFunction<typeof publicGetTicketDefinition> &
    typeof publicGetTicketDefinition
> = /*#__PURE__*/ createRESTModule(publicGetTicketDefinition);
export const deleteTicketDefinition: MaybeContext<
  BuildRESTFunction<typeof publicDeleteTicketDefinition> &
    typeof publicDeleteTicketDefinition
> = /*#__PURE__*/ createRESTModule(publicDeleteTicketDefinition);
export const reorderTicketDefinitions: MaybeContext<
  BuildRESTFunction<typeof publicReorderTicketDefinitions> &
    typeof publicReorderTicketDefinitions
> = /*#__PURE__*/ createRESTModule(publicReorderTicketDefinitions);
export const queryAvailableTicketDefinitions: MaybeContext<
  BuildRESTFunction<typeof publicQueryAvailableTicketDefinitions> &
    typeof publicQueryAvailableTicketDefinitions
> = /*#__PURE__*/ createRESTModule(publicQueryAvailableTicketDefinitions);
export const countTicketDefinitions: MaybeContext<
  BuildRESTFunction<typeof publicCountTicketDefinitions> &
    typeof publicCountTicketDefinitions
> = /*#__PURE__*/ createRESTModule(publicCountTicketDefinitions);
export const countAvailableTicketDefinitions: MaybeContext<
  BuildRESTFunction<typeof publicCountAvailableTicketDefinitions> &
    typeof publicCountAvailableTicketDefinitions
> = /*#__PURE__*/ createRESTModule(publicCountAvailableTicketDefinitions);
export const bulkDeleteTicketDefinitionsByFilter: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteTicketDefinitionsByFilter> &
    typeof publicBulkDeleteTicketDefinitionsByFilter
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteTicketDefinitionsByFilter);
export const changeCurrency: MaybeContext<
  BuildRESTFunction<typeof publicChangeCurrency> & typeof publicChangeCurrency
> = /*#__PURE__*/ createRESTModule(publicChangeCurrency);
export const queryTicketDefinitions: MaybeContext<
  BuildRESTFunction<typeof customQueryTicketDefinitions> &
    typeof customQueryTicketDefinitions
> = /*#__PURE__*/ createRESTModule(customQueryTicketDefinitions);
/**
 * Triggered when a ticket definition is created.
 */
export const onTicketDefinitionCreated: BuildEventDefinition<
  typeof publicOnTicketDefinitionCreated
> &
  typeof publicOnTicketDefinitionCreated = createEventModule(
  publicOnTicketDefinitionCreated
);
/**
 * Triggered when a ticket definition is deleted.
 */
export const onTicketDefinitionDeleted: BuildEventDefinition<
  typeof publicOnTicketDefinitionDeleted
> &
  typeof publicOnTicketDefinitionDeleted = createEventModule(
  publicOnTicketDefinitionDeleted
);
/**
 * Triggered when a ticket sale ends. Sales details aren't included in the response.
 */
export const onTicketDefinitionSaleEnded: BuildEventDefinition<
  typeof publicOnTicketDefinitionSaleEnded
> &
  typeof publicOnTicketDefinitionSaleEnded = createEventModule(
  publicOnTicketDefinitionSaleEnded
);
/**
 * Triggered when a sale period is updated.
 */
export const onTicketDefinitionSalePeriodUpdated: BuildEventDefinition<
  typeof publicOnTicketDefinitionSalePeriodUpdated
> &
  typeof publicOnTicketDefinitionSalePeriodUpdated = createEventModule(
  publicOnTicketDefinitionSalePeriodUpdated
);
/**
 * Triggered when a ticket sale starts. Sales details aren't included in the response.
 */
export const onTicketDefinitionSaleStarted: BuildEventDefinition<
  typeof publicOnTicketDefinitionSaleStarted
> &
  typeof publicOnTicketDefinitionSaleStarted = createEventModule(
  publicOnTicketDefinitionSaleStarted
);
/**
 * Triggered when a ticket definition is updated.
 */
export const onTicketDefinitionUpdated: BuildEventDefinition<
  typeof publicOnTicketDefinitionUpdated
> &
  typeof publicOnTicketDefinitionUpdated = createEventModule(
  publicOnTicketDefinitionUpdated
);

export {
  PricingTypeEnumType,
  FeeTypeEnumType,
  SaleStatusEnumStatus,
  LocationType,
  SubdivisionSubdivisionType,
  RecurrenceStatusStatus,
  Status,
  Field,
  SortOrder,
  CancellationActorType,
  LocationLocationType,
  SubdivisionType,
  EventsRecurrenceStatusStatus,
  EventStatus,
  EventType,
  RegistrationStatus,
  RsvpStatusOptions,
  TaxType,
  CheckoutType,
  VisitorType,
  InputControlType,
  ValueType,
  ConferenceType,
  CategoryStateState,
  NodeType,
  BackgroundType,
  GradientType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  TextAlignment,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  FontType,
  Variant,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  CardStylesType,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  ImagePosition,
  LayoutDataBackgroundType,
  Origin,
  BannerPosition,
  BackdropType,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SmartBlockDataType,
  ColumnSize,
  Type,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './events-v3-ticket-definition-ticket-definitions-v-2.universal.js';
export {
  TicketDefinition,
  SalePeriod,
  PricingMethod,
  PricingMethodPriceOneOf,
  CommonMoney,
  PricingOptions,
  OptionDetails,
  SalesDetails,
  ExtendedFields,
  EventDetails,
  Location,
  CommonAddress,
  CommonAddressStreetOneOf,
  CommonStreetAddress,
  CommonAddressLocation,
  CommonSubdivision,
  DateAndTimeSettings,
  Recurrences,
  Occurrence,
  Formatted,
  SeatingDetails,
  AvailablePlace,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  SalePeriodUpdated,
  TicketDefinitionSaleStarted,
  TicketDefinitionSaleEnded,
  CreateTicketDefinitionRequest,
  CreateTicketDefinitionResponse,
  UpdateTicketDefinitionRequest,
  UpdateTicketDefinitionResponse,
  GetTicketDefinitionRequest,
  GetTicketDefinitionResponse,
  DeleteTicketDefinitionRequest,
  DeleteTicketDefinitionResponse,
  ReorderTicketDefinitionsRequest,
  ReorderTicketDefinitionsRequestReferenceDefinitionOneOf,
  ReorderTicketDefinitionsResponse,
  UpdateTicketDefinitionSortIndexRequest,
  UpdateTicketDefinitionSortIndexResponse,
  QueryTicketDefinitionsRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  Paging,
  CursorPaging,
  QueryTicketDefinitionsResponse,
  PagingMetadataV2,
  Cursors,
  QueryAvailableTicketDefinitionsRequest,
  QueryAvailableTicketDefinitionsResponse,
  CountTicketDefinitionsRequest,
  CountTicketDefinitionsResponse,
  FacetCounts,
  CountAvailableTicketDefinitionsRequest,
  CountAvailableTicketDefinitionsResponse,
  BulkDeleteTicketDefinitionsByFilterRequest,
  BulkDeleteTicketDefinitionsByFilterResponse,
  ChangeCurrencyRequest,
  ChangeCurrencyResponse,
  BulkCopyTicketDefinitionsByEventIdRequest,
  BulkCopyTicketDefinitionsByEventIdResponse,
  CopiedTicketDefinition,
  UpdateFeeTypesBasedOnSettingsRequest,
  UpdateFeeTypesBasedOnSettingsResponse,
  EventDeleted,
  Empty,
  EventCanceled,
  CancellationActor,
  EventEnded,
  EventCreated,
  EventsLocation,
  MapCoordinates,
  Address,
  AddressStreetOneOf,
  StreetAddress,
  AddressLocation,
  Subdivision,
  ScheduleConfig,
  EventsRecurrences,
  EventsOccurrence,
  Event,
  Scheduling,
  Registration,
  RsvpCollection,
  RsvpCollectionConfig,
  RsvpConfirmationMessages,
  RsvpConfirmationMessagesPositiveResponseConfirmation,
  RsvpConfirmationMessagesNegativeResponseConfirmation,
  Ticketing,
  TicketingConfig,
  TaxConfig,
  TicketsConfirmationMessages,
  Money,
  ExternalEvent,
  CalendarLinks,
  SiteUrl,
  Form,
  InputControl,
  Input,
  OptionSelection,
  OptionSelectionSelectedOptionOneOf,
  Label,
  FormMessages,
  RsvpFormMessages,
  PositiveResponseConfirmation,
  NegativeResponseConfirmation,
  Positive,
  Negative,
  CheckoutFormMessages,
  ResponseConfirmation,
  RegistrationClosedMessages,
  TicketsUnavailableMessages,
  Dashboard,
  RsvpSummary,
  TicketingSummary,
  CancellationInfo,
  GuestListConfig,
  Feed,
  OnlineConferencing,
  OnlineConferencingConfig,
  OnlineConferencingSession,
  SeoSettings,
  SeoSchema,
  Keyword,
  Tag,
  Settings,
  Agenda,
  Category,
  CategoryCounts,
  EventDisplaySettings,
  LabellingSettings,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Gradient,
  Stop,
  Border,
  Colors,
  Background,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  CodeBlockData,
  TextStyle,
  DividerData,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  ImageDataCrop,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  PollSettings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  SketchData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackground,
  LayoutDataBackgroundImage,
  Banner,
  Backdrop,
  LayoutCellData,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  SmartBlockData,
  SmartBlockCellData,
  CheckboxListData,
  ListItemNodeData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  Badge,
  EventUpdated,
  SeatingPlanCategoriesSummaryUpdated,
  CategoryDetails,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  GetTicketDefinitionFromTrashBinRequest,
  GetTicketDefinitionFromTrashBinResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  GetTicketDefinitionSummaryRequest,
  GetTicketDefinitionSummaryResponse,
  TicketDefinitionSummary,
  ListEventTicketingSummaryRequest,
  ListEventTicketingSummaryResponse,
  EventTicketingSummary,
  UpdateEventTicketingSummaryRequest,
  UpdateEventTicketingSummaryResponse,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  TicketDefinitionCreatedEnvelope,
  TicketDefinitionDeletedEnvelope,
  TicketDefinitionSaleEndedEnvelope,
  TicketDefinitionSalePeriodUpdatedEnvelope,
  TicketDefinitionSaleStartedEnvelope,
  TicketDefinitionUpdatedEnvelope,
  CreateTicketDefinitionOptions,
  UpdateTicketDefinition,
  UpdateTicketDefinitionOptions,
  GetTicketDefinitionOptions,
  ReorderTicketDefinitionsOptions,
  ReorderTicketDefinitionsOptionsReferenceDefinitionOneOf,
  QueryTicketDefinitionsOptions,
  TicketDefinitionsQueryResult,
  TicketDefinitionsQueryBuilder,
  TicketDefinitionQuerySpec,
  QueryAvailableTicketDefinitionsOptions,
  CountTicketDefinitionsOptions,
  CountAvailableTicketDefinitionsOptions,
  ChangeCurrencyOptions,
} from './events-v3-ticket-definition-ticket-definitions-v-2.universal.js';
export { utils } from './events-v3-ticket-definition-ticket-definitions-v-2.universal.js';
export {
  PricingTypeEnumTypeWithLiterals,
  FeeTypeEnumTypeWithLiterals,
  SaleStatusEnumStatusWithLiterals,
  LocationTypeWithLiterals,
  SubdivisionSubdivisionTypeWithLiterals,
  RecurrenceStatusStatusWithLiterals,
  StatusWithLiterals,
  FieldWithLiterals,
  SortOrderWithLiterals,
  CancellationActorTypeWithLiterals,
  LocationLocationTypeWithLiterals,
  SubdivisionTypeWithLiterals,
  EventsRecurrenceStatusStatusWithLiterals,
  EventStatusWithLiterals,
  EventTypeWithLiterals,
  RegistrationStatusWithLiterals,
  RsvpStatusOptionsWithLiterals,
  TaxTypeWithLiterals,
  CheckoutTypeWithLiterals,
  VisitorTypeWithLiterals,
  InputControlTypeWithLiterals,
  ValueTypeWithLiterals,
  ConferenceTypeWithLiterals,
  CategoryStateStateWithLiterals,
  NodeTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  TargetWithLiterals,
  TextAlignmentWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  VariantWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  CardStylesTypeWithLiterals,
  AlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  ImagePositionWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  OriginWithLiterals,
  BannerPositionWithLiterals,
  BackdropTypeWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SmartBlockDataTypeWithLiterals,
  ColumnSizeWithLiterals,
  TypeWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateTicketDefinitionApplicationErrors,
  UpdateTicketDefinitionApplicationErrors,
  ReorderTicketDefinitionsApplicationErrors,
  CountTicketDefinitionsApplicationErrors,
  CountAvailableTicketDefinitionsApplicationErrors,
  ChangeCurrencyApplicationErrors,
  CommonQueryWithEntityContext,
  TicketDefinitionQuery,
} from './events-v3-ticket-definition-ticket-definitions-v-2.universal.js';
